export default "__VITE_ASSET__2NYOYp5a__"